import React, { useContext } from 'react';
import RecorderDrawerContext from '../../Context';
import { ViewWebsiteButton } from '../ViewWebsiteButton';

export function SingleProfileDetails() {
  const { profiles } = useContext(RecorderDrawerContext);
  const profile = profiles?.[0];

  if (!profile) return <></>;

  return (
    <>
      <div className='flex flex-row gap-x-3 items-center'>
        <img className='rounded-full h-12 w-12' src={profile.image} />
        <span className='v2-text-neutral-900 text-base'>{profile.name}</span>
      </div>
      <ViewWebsiteButton email={profile.email} />
      <div className='flex flex-row gap-x-4 items-center'>
        <i className='icon icon-email !v2-bg-neutral-500' />
        <span className='v2-text-neutral-500 text-base'>{profile.email}</span>
      </div>
      <div className='text-base'>{profile.summary}</div>
    </>
  );
}
